<template>
  <div>
    <FilterOption :is-affiliation="false" @option="onOptionChange"/>
    <ECometencys :caption="objs.title" class="mb-3" v-for="objs in objsItem.item" :key="objs" :item="objs.item" level="2" />
    <CRow>
      <CCol class="text-right mr-3 mb-4" >
        <CButton class="mr-2" size="sm" color="success" shape="pill" variant="outline" @click="onAddCompetency()"  >
          <span class="font-weight-bold pr-1"><CIcon name="cil-plus" /> ADD </span>
        </CButton>
        <CButton size="sm" color="info" shape="pill" variant="outline" @click="onSaveCompetency()"  >
          <span class="font-weight-bold pr-1"><CIcon name="cil-save" /> SAVE </span>
        </CButton>
      </CCol>
    </CRow>

    <CRow>
      <CCol>

      </CCol>
    </CRow>

  </div>
</template>

<script>


import {mapGetters} from 'vuex'
import ECometencys from "@/projects/views/E-Performances/Estimate/components/ECometencys";
import FilterOption from "@/projects/views/E-Performances/Estimate/components/FilterOption";
export default {
  name: 'EDashborad',
  components: {FilterOption, ECometencys },
  props:{
    caption:{
      type: String,
      default: ""
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      option: {
        organization: null,
        year: new Date().getFullYear() + 543,
      },
    }
  },

  mounted () {
  },

  created () {
    this.onInit()

  },
  beforeDestroy () {

  },

  methods: {
    onInit(){
      var data = {};
      this.$store.dispatch("assessment/config", data)
    },


    onOptionChange(e){
      this.option = e

      var body = {};
      body.organization = e.organization;
      body.year = parseInt(e.year);
      this.objsItem = []
      this.$store.dispatch("estimate/config",body)
    },

    onAddCompetency(){

      var objs = {}
      objs.description = [
        {
          "value": "",
          "key": "en"
        },
        {
          "value": "",
          "key": "th"
        }
      ];
      objs.title = [
        {
          "value": "",
          "key": "en"
        },
        {
          "value": "",
          "key": "th"
        }
      ];

      var objsI = {}
      objsI.description = [
        {
          "value": "",
          "key": "en"
        },
        {
          "value": "",
          "key": "th"
        }
      ];
      objsI.title = [
        {
          "value": "",
          "key": "en"
        },
        {
          "value": "",
          "key": "th"
        }
      ];
      objsI.levels = []

      for(var i=0; i<6; i++){
        var objsL = {}
        objsL.description = [
          {
            "value": "",
            "key": "en"
          },
          {
            "value": "",
            "key": "th"
          }
        ];
        objsL.title = [
          {
            "value": "",
            "key": "en"
          },
          {
            "value": "",
            "key": "th"
          }
        ];
        objsL.item = [];
        objsI.levels.push(objsL);
      }

      objs.item = [];
      objs.item.push(objsI)
      this.objsItem.item.push(objs)
    },

    onOption(item){
      this.option = item;
    },

    onSaveCompetency(){
      var objs = {};
      objs.year = parseInt( this.option.year);
      objs.organization = this.option.organization;
      // objs.affiliations = this.option.affiliations;
      objs.item =  this.objsItem.item;
      //
      //
      this.$store.dispatch("assessment/create",objs)

    }

  },



  computed:{
    ...mapGetters({
      objsLang : "setting/lang",
      objsItem : "assessment/assessment",
    }),
  },

  watch: {

  }

}
</script>
<style >
</style>
